import { Button, Empty, Flex, Typography } from 'antd';
import React, { FunctionComponent, useEffect } from 'react';
import { useVideoContext } from '../../../hooks/use-video';
import SceneItem from './scene/scene';

import './scenes.scss';
import SceneLayoutActions from './scene/scene-layout-actions';
import { PlusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const Scenes: FunctionComponent = () => {
  const { t } = useTranslation();
  const { scenes, scrollToScene, getCurrentFrame, getSceneByCurrentFrame } =
    useVideoContext();

  // useEffect(() => {
  //   if (scenes.length === 0) {
  //     return;
  //   }
  //
  //   const currentFrame = getCurrentFrame();
  //   const currentScene = getSceneByCurrentFrame(currentFrame);
  //
  //   if (currentScene) {
  //     scrollToScene(currentScene);
  //   }
  // }, []);

  if (scenes.length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '32px 0',
        }}
      >
        <Empty
          description={
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
              }}
            >
              <Typography.Text>
                {t('videoEditor.scenes.noScenes')}
              </Typography.Text>
              <Typography.Text type="secondary">
                {t('videoEditor.scenes.noScenesHint')}
              </Typography.Text>
            </div>
          }
        />
        <div style={{ marginTop: '24px' }}>
          <SceneLayoutActions />
        </div>
      </div>
    );
  }
  let currentTime = 0;

  return (
    <div className="scenes">
      <Flex vertical gap="large">
        {scenes.map((scene, index) => {
          const isLast = index === scenes.length - 1;
          const sceneTime = currentTime;
          currentTime += scene.duration;

          return (
            <SceneItem
              key={scene._id}
              sceneId={scene._id}
              sceneNumber={index + 1}
              currentTime={sceneTime}
            />
          );
        })}
      </Flex>
    </div>
  );
};

export default Scenes;
